export const installPwaModal = `
<div class="fixed p-4 left-0 top-0 flex h-full w-full items-center justify-center bg-black bg-opacity-50 py-10 z-10">
  <div class="max-h-full p-6 w-full max-w-xl overflow-y-auto bg-white relative">
    <button class="absolute top-4 right-4 p-2 close-install-modal">X</button>
    <div class="w-full">
      <div class="m-8 my-10 max-w-[400px] mx-auto">
        <div class="mb-8">
          <h1 class="mb-4 text-3xl font-extrabold">Zainstaluj aplikację</h1>
          <p class="text-gray-text">Kliknij przycisk aby zainstalować aplikację na swoim urządzeniu</p>
        </div>
        <div class="flex gap-2">
          <button id="install-button" class="btn-primary mt-0">Instaluj</button>
          <button class="btn-secondary mt-0 close-install-modal">Anuluj</button>
        </div>
      </div>
    </div>
  </div>
</div>`;

export const iosInstallPwaModal = `
<div class="fixed p-4 left-0 top-0 flex h-full w-full items-center justify-center bg-black bg-opacity-50 py-10 z-10">
  <div class="max-h-full p-6 w-full max-w-xl overflow-y-auto bg-white relative">
    <button class="absolute top-4 right-4 p-2 close-install-modal">X</button>
    <div class="w-full">
      <div class="m-8 my-10 max-w-[400px] mx-auto">
        <div class="mb-8">
          <h1 class="mb-4 text-3xl font-extrabold">Zainstaluj aplikację</h1>
          <p class="text-gray-text">Aby zainstalować aplikację kliknij przycisk "udostępnij" a następnie "do ekranu początkowego"</p>
          <img class="mt-4" src="/ios_install_pwa_share.jpg" />
          <img class="mt-4" src="/ios_install_pwa_add.jpg" /> 
        </div>
      </div>
    </div>
  </div>
`;

export const allowNotificationsModal = `
<div class="fixed p-4 left-0 top-0 flex h-full w-full items-center justify-center bg-black bg-opacity-50 py-10 z-10">
  <div class="max-h-full w-full max-w-xl overflow-y-auto bg-white relative">
    <button class="absolute top-4 right-4 p-2" id="close-allow-notifications-modal">X</button>
    <div class="w-full p-6">
      <div class="m-8 my-20 max-w-[400px] mx-auto">
        <div class="mb-8">
          <div class="flex gap-4 justify-center items-center mb-4">
          <h1 class="text-3xl font-extrabold">Włącz notyfikacje </h1>
          <svg class="w-8 h-8" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
            <path d="M11.209 3.816a1 1 0 0 0-1.966.368l.325 1.74a5.338 5.338 0 0 0-2.8 5.762l.276 1.473.055.296c.258 1.374-.228 2.262-.63 2.998-.285.52-.527.964-.437 1.449.11.586.22 1.173.75 1.074l12.7-2.377c.528-.1.418-.685.308-1.27-.103-.564-.636-1.123-1.195-1.711-.606-.636-1.243-1.306-1.404-2.051-.233-1.085-.275-1.387-.303-1.587-.009-.063-.016-.117-.028-.182a5.338 5.338 0 0 0-5.353-4.39l-.298-1.592Z"/>
            <path fill-rule="evenodd" d="M6.539 4.278a1 1 0 0 1 .07 1.412c-1.115 1.23-1.705 2.605-1.83 4.26a1 1 0 0 1-1.995-.15c.16-2.099.929-3.893 2.342-5.453a1 1 0 0 1 1.413-.069Z" clip-rule="evenodd"/>
            <path d="M8.95 19.7c.7.8 1.7 1.3 2.8 1.3 1.6 0 2.9-1.1 3.3-2.5l-6.1 1.2Z"/>
          </svg>
          </div>
          <p class="text-gray-600">Pozwól nam na wysyłanie Ci informacji o nowych promocjach i akcjach specjalnych, dzięki którym możesz zgarnąć jeszcze większe premie finansowe!</p>
        </div>
        <div class="space-y-4 flex-col md:flex-row flex gap-4">
          <button id="allow-notifications" class="basis-1/2 btn-primary !mt-0">Zezwól</button>
          <button id="reject-notifications" class="basis-1/2 btn-secondary !mt-0">Odmów</button>
        </div>
      </div>
    </div>
  </div>
</div>
`;
